import booksData from '/data/books.json';

function createCategorySection(category, items) {
  const section = document.createElement('section');
  section.style.margin = '1.5rem 0 2.5rem 0';

  const header = document.createElement('h2');
  header.textContent = category;
  header.style.fontSize = '1.5rem';
  header.style.margin = '0 0 1rem 0';
  header.style.color = '#111827';
  header.style.fontWeight = '700';

  const grid = document.createElement('div');
  grid.style.display = 'grid';
  grid.style.gridTemplateColumns = 'repeat(auto-fill, minmax(180px, 1fr))';
  grid.style.gap = '1.25rem';

  items.forEach((book) => {
    const card = document.createElement('a');
    card.href = book.url;
    card.target = '_blank';
    card.rel = 'noopener';
    card.style.display = 'flex';
    card.style.flexDirection = 'column';
    card.style.background = '#ffffff';
    card.style.borderRadius = '12px';
    card.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
    card.style.overflow = 'hidden';
    card.style.textDecoration = 'none';
    card.style.color = '#111827';
    card.style.transition = 'transform 0.2s ease, box-shadow 0.2s ease';

    card.addEventListener('mouseenter', () => {
      card.style.transform = 'translateY(-2px)';
      card.style.boxShadow = '0 8px 20px rgba(0,0,0,0.12)';
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = 'translateY(0)';
      card.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
    });

    const imgWrap = document.createElement('div');
    imgWrap.style.width = '100%';
    imgWrap.style.aspectRatio = '3 / 4';
    imgWrap.style.background = '#f8fafc';
    imgWrap.style.display = 'flex';
    imgWrap.style.alignItems = 'center';
    imgWrap.style.justifyContent = 'center';

    const img = document.createElement('img');
    img.src = book.image;
    img.alt = book.title;
    img.style.maxWidth = '100%';
    img.style.maxHeight = '100%';
    img.style.objectFit = 'contain';
    img.style.borderBottom = '1px solid #eef2f6';

    imgWrap.appendChild(img);

    const body = document.createElement('div');
    body.style.padding = '0.75rem 0.9rem 1rem 0.9rem';

    const title = document.createElement('h3');
    title.textContent = book.title;
    title.style.fontSize = '1rem';
    title.style.lineHeight = '1.35';
    title.style.margin = '0 0 0.5rem 0';
    title.style.fontWeight = '600';

    const desc = document.createElement('p');
    desc.textContent = book.description;
    desc.style.fontSize = '0.95rem';
    desc.style.lineHeight = '1.5';
    desc.style.color = '#4b5563';
    desc.style.margin = '0';

    body.appendChild(title);
    body.appendChild(desc);

    card.appendChild(imgWrap);
    card.appendChild(body);
    grid.appendChild(card);
  });

  section.appendChild(header);
  section.appendChild(grid);
  return section;
}

function createBooksGrid(items) {
  const grid = document.createElement('div');
  grid.style.display = 'grid';
  grid.style.gridTemplateColumns = 'repeat(auto-fill, minmax(180px, 1fr))';
  grid.style.gap = '1.25rem';

  items.forEach((book) => {
    const card = document.createElement('a');
    card.href = book.url;
    card.target = '_blank';
    card.rel = 'noopener';
    card.style.display = 'flex';
    card.style.flexDirection = 'column';
    card.style.background = '#ffffff';
    card.style.borderRadius = '12px';
    card.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
    card.style.overflow = 'hidden';
    card.style.textDecoration = 'none';
    card.style.color = '#111827';
    card.style.transition = 'transform 0.2s ease, box-shadow 0.2s ease';

    card.addEventListener('mouseenter', () => {
      card.style.transform = 'translateY(-2px)';
      card.style.boxShadow = '0 8px 20px rgba(0,0,0,0.12)';
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = 'translateY(0)';
      card.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
    });

    const imgWrap = document.createElement('div');
    imgWrap.style.width = '100%';
    imgWrap.style.aspectRatio = '3 / 4';
    imgWrap.style.background = '#f8fafc';
    imgWrap.style.display = 'flex';
    imgWrap.style.alignItems = 'center';
    imgWrap.style.justifyContent = 'center';

    const img = document.createElement('img');
    img.src = book.image;
    img.alt = book.title;
    img.style.maxWidth = '100%';
    img.style.maxHeight = '100%';
    img.style.objectFit = 'contain';
    img.style.borderBottom = '1px solid #eef2f6';

    imgWrap.appendChild(img);

    const body = document.createElement('div');
    body.style.padding = '0.75rem 0.9rem 1rem 0.9rem';

    const title = document.createElement('h3');
    title.textContent = book.title;
    title.style.fontSize = '1rem';
    title.style.lineHeight = '1.35';
    title.style.margin = '0 0 0.5rem 0';
    title.style.fontWeight = '600';

    const desc = document.createElement('p');
    desc.textContent = book.description;
    desc.style.fontSize = '0.95rem';
    desc.style.lineHeight = '1.5';
    desc.style.color = '#4b5563';
    desc.style.margin = '0';

    body.appendChild(title);
    body.appendChild(desc);

    card.appendChild(imgWrap);
    card.appendChild(body);
    grid.appendChild(card);
  });

  return grid;
}

function shuffleArray(items) {
  const array = items.slice();
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function init() {
  const root = document.getElementById('books-root');
  if (!root) return;

  const books = booksData.books || [];
  const shuffledBooks = shuffleArray(books);
  const categoryToBooks = new Map();
  books.forEach((b) => {
    const key = b.category || 'Altro';
    if (!categoryToBooks.has(key)) categoryToBooks.set(key, []);
    categoryToBooks.get(key).push(b);
  });

  // Sort categories by a sensible order
  const order = [
    'Finanza personale',
    'Finanza comportamentale',
    'Investimenti',
    'Economia',
    'Produttività e focus',
    'Crescita personale',
    'Creatività e problem solving',
    'Startup e business',
    'Altro'
  ];

  const categories = Array.from(categoryToBooks.keys()).sort((a, b) => {
    const ia = order.indexOf(a);
    const ib = order.indexOf(b);
    if (ia === -1 && ib === -1) return a.localeCompare(b);
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
  });

  // UI containers: info bar (result count + clear), filter pills, and content
  const infoBar = document.createElement('div');
  infoBar.style.display = 'flex';
  infoBar.style.alignItems = 'center';
  infoBar.style.justifyContent = 'space-between';
  infoBar.style.margin = '0 0 0.75rem 0';

  const resultCount = document.createElement('span');
  resultCount.style.fontSize = '0.95rem';
  resultCount.style.color = '#4b5563';

  const clearButton = document.createElement('button');
  clearButton.type = 'button';
  clearButton.textContent = 'Azzera filtri';
  clearButton.style.padding = '0.35rem 0.6rem';
  clearButton.style.borderRadius = '8px';
  clearButton.style.border = '1px solid #e5e7eb';
  clearButton.style.background = '#ffffff';
  clearButton.style.color = '#111827';
  clearButton.style.fontSize = '0.9rem';
  clearButton.style.cursor = 'pointer';
  clearButton.style.display = 'none';

  infoBar.appendChild(resultCount);
  infoBar.appendChild(clearButton);

  const filterContainer = document.createElement('div');
  filterContainer.style.display = 'flex';
  filterContainer.style.flexWrap = 'wrap';
  filterContainer.style.gap = '0.5rem';
  filterContainer.style.margin = '0 0 1rem 0';

  const contentContainer = document.createElement('div');

  root.appendChild(infoBar);
  root.appendChild(filterContainer);
  root.appendChild(contentContainer);

  const selectedCategories = new Set();

  function updateResultsCount(totalShown) {
    if (selectedCategories.size === 0) {
      resultCount.textContent = `Tutti i libri: ${books.length}`;
    } else {
      resultCount.textContent = `Risultati: ${totalShown}`;
    }
  }

  function render() {
    contentContainer.innerHTML = '';
    const visibleBooks = selectedCategories.size === 0
      ? shuffledBooks
      : shuffledBooks.filter((b) => selectedCategories.has(b.category || 'Altro'));

    const totalShown = visibleBooks.length;
    const grid = createBooksGrid(visibleBooks);
    contentContainer.appendChild(grid);

    updateResultsCount(totalShown);
    clearButton.style.display = selectedCategories.size === 0 ? 'none' : 'inline-block';
  }

  // Build filter pills
  categories.forEach((cat) => {
    const pill = document.createElement('button');
    pill.type = 'button';
    pill.textContent = cat;
    pill.setAttribute('aria-pressed', 'false');
    pill.style.padding = '0.35rem 0.6rem';
    pill.style.borderRadius = '9999px';
    pill.style.border = '1px solid #e5e7eb';
    pill.style.background = '#f8fafc';
    pill.style.color = '#111827';
    pill.style.fontSize = '0.9rem';
    pill.style.cursor = 'pointer';
    pill.style.transition = 'all 0.15s ease';

    function setSelected(isSelected) {
      pill.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      pill.style.background = isSelected ? '#111827' : '#f8fafc';
      pill.style.color = isSelected ? '#ffffff' : '#111827';
      pill.style.border = isSelected ? '1px solid #111827' : '1px solid #e5e7eb';
    }

    pill.addEventListener('click', () => {
      if (selectedCategories.has(cat)) {
        selectedCategories.delete(cat);
        setSelected(false);
      } else {
        selectedCategories.add(cat);
        setSelected(true);
      }
      render();
    });

    pill.addEventListener('mouseenter', () => {
      if (!selectedCategories.has(cat)) {
        pill.style.background = '#eef2f6';
      }
    });
    pill.addEventListener('mouseleave', () => {
      if (!selectedCategories.has(cat)) {
        pill.style.background = '#f8fafc';
      }
    });

    filterContainer.appendChild(pill);
  });

  clearButton.addEventListener('click', () => {
    selectedCategories.clear();
    Array.from(filterContainer.children).forEach((node) => {
      if (node.tagName === 'BUTTON') {
        node.setAttribute('aria-pressed', 'false');
        node.style.background = '#f8fafc';
        node.style.color = '#111827';
        node.style.border = '1px solid #e5e7eb';
      }
    });
    render();
  });

  render();
}

document.addEventListener('DOMContentLoaded', init);

